// External dependencies
var $ = require('jquery')
var window = require('window')
var errorLogin = require('errorLogin')
var errorSignup = require('errorSignup')

$(window.document).ready(function(){
  if(errorLogin) $('#modal_login').modal('show')
  if(errorSignup) $('#modal_signup').modal('show')
  $('.modal-auth .open-modal').click(function(){
    var closeModal = $('#'+$(this).data().closeModal)
    closeModal.modal('hide').data('openModal', $(this).data().openModal)
  })
  $('.modal-auth').on('show.bs.modal', function(e){
    $(this).data('openModal', null)
  })
  $('.modal-auth').on('hidden.bs.modal', function (e) {
    var openModal = $(this).data().openModal
    if(openModal) $('#'+openModal).modal('show')
  })
})
